@if (assistantEnabled() && assistantEntitled()) {
  <ng-template
    #overlay="rtConnectedOverlay"
    rt-connected-overlay
    [origin]="overlayOrigin"
    [positions]="positions"
    [rtConnectedOverlayAutoClose]="false"
    [hasBackdrop]="true"
    [open]="chatOpen()"
    (backdropClick)="toggleChat()"
  >
    <hr-assistant-chat
      [userAvatar]="userData().avatar"
      [userFullName]="userData().name"
      [wikiEnabled]="assistantConfig()?.wiki?.enabled ?? false"
      [conversationStarters]="assistantConfig()?.wiki?.questions ?? []"
      [greeting]="assistantConfig()?.greeting ?? ''"
      [rtFeatureTooltip]="hrAssistantFeatureTooltip()"
      [rtFeatureTooltipEnabled]="hrAssistantFeatureTooltipEnabled()"
      (rtFeatureTooltipDismissed)="onFeatureTooltipDismissed()"
      (close)="toggleChat()"
      margin-tb
    />
  </ng-template>

  <hr-assistant-trigger
    #overlayOrigin="rtOverlayOrigin"
    rt-overlay-origin
    [forceHoverState]="overlay.open"
    [withHover]="true"
    (click)="toggleChat(); trackTriggerClick()"
  />
}
